<div class="modal-header">
    <h5 class="modal-title">Ekipman Hareketi</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="assignmentMovement">
        <div class="row">

            <!-- Movement Type -->
            <div class="mb-2 col-md-6">
                <label class="form-label">Hareket Türü</label>
                <ng-select formControlName="movementType" [items]="movementTypes" bindLabel="label" bindValue="value"
                    placeholder="Hareket Türü Seçiniz">
                </ng-select>
            </div>

            <!-- Movement Date -->
            <div class="mb-2 col-md-6">
                <label class="form-label">Hareket Tarihi</label>
                <ng2-flatpickr [config]="dateTimeStartOptions" formControlName="movementDate"
                    [setDate]="date"></ng2-flatpickr>

            </div>
            <!-- From Person -->
            <div class="mb-2 col-md-6"
                *ngIf="assignmentMovement.get('movementType')?.value !== 6 && assignmentMovement.get('movementType')?.value !== 5">
                <label class=" form-label">Teslim Eden Kişi</label>
                <ng-select formControlName="fromPersonId" [items]="fromPersonList" bindLabel="fullName" bindValue="id"
                    groupBy="companyName" [searchFn]="customSearchFn" (search)="onFromPersonSearch($event)"
                    placeholder="Kişi Seçiniz">

                    <ng-template ng-optgroup-tmp let-item="item">
                        {{ item.companyName }}
                    </ng-template>
                </ng-select>
            </div>

            <!-- To Person -->
            <div class="mb-2 col-md-6"
                *ngIf="assignmentMovement.get('movementType')?.value !== 6 && assignmentMovement.get('movementType')?.value !== 5">
                <label class="form-label">Teslim Alan Kişi</label>
                <ng-select formControlName="toPersonId" [items]="toPersonList" bindLabel="fullName" bindValue="id"
                    groupBy="companyName" [searchFn]="customSearchFn" (search)="onToPersonSearch($event)"
                    placeholder="Kişi Seçiniz">

                    <ng-template ng-optgroup-tmp let-item="item">
                        {{ item.companyName }}
                    </ng-template>
                </ng-select>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12">
                <label>İşlem Yapan Personel</label>
                <input type="text" class="form-control" readonly [value]="authService.isUserNameAndLastName">
            </div>
        </div>
        <div class="mb-2">
            <label class="form-label">Açıklama</label>
            <textarea rows="3" formControlName="description" class="form-control"
                placeholder="Açıklama giriniz..."></textarea>
        </div>
    </form>
</div>

<div class="modal-footer justify-content-between">
    <div *ngIf="!data.id">
        <p class="text-white">{{equipment.lastMovement?.personName}}</p>
    </div>
    <div *ngIf="data.id">
        <p class="text-white">{{assignmentMovementData.personName}}</p>
    </div>
    <div>
        <button class="btn btn-secondary" (click)="activeModal.dismiss()">İptal</button>
        <button class="btn btn-primary" [disabled]="assignmentMovement.invalid || isSubmitting"
            (click)="save()">Kaydet</button>
    </div>
</div>